export default __webpack_public_path__ + "static/media/peperoncini.98ab70b7.mp3";